import React, {Component} from 'react'

class TableFilter extends Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.state = {
      active: props.active
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      active: props.active
    });
  }

  onChange(filter) {
    this.setState({active: !this.state.active}, () => {this.props.onChange(this.state.active ? filter : '')})
  }

  render() {
    return (
      <button className={`m-2 btn table-filter-button ${this.state.active  ? 'table-filter-button-active' : ''}`} id={this.props.value} onClick={() => this.onChange(this.props.value)}>
        {this.props.label}
      </button>
    )
  }
}

export default TableFilter
